import AuthState from '@/models/auth/auth-state.model';
import UserLogin from '@/models/auth/user-login.model';
import RememberPassword from '@/models/auth/auth-remember-password.model';
import RecoveryPassword from '@/models/auth/auth-recovery-password.model';
import { MutationTree } from "vuex";

export const mutations: MutationTree<AuthState> = {
    setUserLogin(state, userLogin: any) {
        const newUser: UserLogin = { ...state.userLogin, ...userLogin };
        state.userLogin = new UserLogin(newUser.username, newUser.password);
    },
    setRememberPassword(state, rememberPassword: any) {
        const newRememberPassword: RememberPassword = { ...state.rememberPassword, ...rememberPassword };
        state.rememberPassword = new RememberPassword(newRememberPassword.username);
    },
    setRecoveryPassword(state, recoveryPassword: any) {
        const newRecoveryPassword: RecoveryPassword = { ...state.recoveryPassword, ...recoveryPassword };
        state.recoveryPassword = new RecoveryPassword(newRecoveryPassword.password, newRecoveryPassword.confirmPassword, newRecoveryPassword.pin );
    },
    setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    setIsSubmitted(state, isSubmitted: boolean) {
        state.isSubmitted = isSubmitted;
    },
    setIsErrorLogin(state, isErrorLogin: boolean) {
        state.isErrorLogin = isErrorLogin;
    },
    setIsErrorRequest(state, isErrorRequest: boolean) {
        state.isErrorRequest = isErrorRequest;
    }
};
